const styles = (theme) => ({
  toastContainer: {
    "& .Toastify__progress-bar-theme--light": {
      background: theme.palette.mainGradient,
    },
  }
});

export default styles;
